import { useCallback, useState } from "react";
import SearchUsersCard from "../../components/card/SearchUsersCard";
import { useTranslation } from "react-i18next";
import SearchUsersTable from "../../components/table/SearchUsersTable";
import { Button } from "../../components/button";
import { useSyncADUser } from "../../hooks/common/mutation";
import toast from "react-hot-toast";
import { APP_ROUTES } from "../../routes";
import { useNavigate } from "react-router-dom";
import BackButton from "../../components/button/BackButton";
import { ExportUsersForExcelPDFBody } from "../../hooks/user/interface";
import { PAGE_SIZE } from "../../constants/common";

const SearchUsers = () => {
  const { t } = useTranslation();

  const [exportBody, setExportBody] = useState<ExportUsersForExcelPDFBody>();

  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);

  const navigate = useNavigate();

  const [search, setSearch] = useState("");

  const [allUsers, setAllUsers] = useState([]);

  const { mutateAsync: SyncADUser, isPending: isSyncADUserLoading } =
    useSyncADUser();

  const handleSyncAdUsers = useCallback(async () => {
    try {
      await SyncADUser();
      toast.success(t("syncedSuccessfully"));
    } catch (error) {
      toast.error(t("somethingWentWrong"));
    }
  }, [SyncADUser, t]);

  return (
    <div className="flex flex-col gap-4 md:gap-8">
      <div className="flex items-center justify-between">
        <h1 className="text-xl md:text-2xl dark:text-white">
          {t("searchUsers")}
        </h1>

        <div className="flex items-center gap-2">
          <Button
            type="button"
            isLoading={isSyncADUserLoading}
            onClick={handleSyncAdUsers}
            className="bg-transparent ring-1 ring-purple-primary text-purple-primary hover:bg-transparent dark:!ring-white dark:text-white"
          >
            {t("SyncADUsers")}
          </Button>

          <Button
            type="button"
            onClick={() => navigate(APP_ROUTES.ADD_USERS)}
            className="bg-transparent ring-1 ring-purple-primary text-purple-primary hover:bg-transparent dark:!ring-white dark:text-white"
          >
            {t("addUsers")}
          </Button>

          <BackButton />
        </div>
      </div>

      <SearchUsersCard
        setAllUsers={setAllUsers}
        page={page}
        search={search}
        setPages={setPages}
        setCount={setCount}
        setExportBody={setExportBody}
        pageSize={pageSize}
      />

      <SearchUsersTable
        allUsers={allUsers}
        page={page}
        pages={pages}
        setPage={setPage}
        search={search}
        setSearch={setSearch}
        count={count}
        exportBody={exportBody}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default SearchUsers;
